import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../api';

// Placeholder descriptions (Since backend doesn't have them yet)
const MOCK_DESCRIPTIONS = {
  "Dhoop": "Experience the calming essence of our natural Dhoop cones, perfect for meditation and prayer.",
  "Agarbatti": "Our premium Agarbatti sticks are hand-rolled with the finest natural fragrances to uplift your home.",
  "Pooja Samagri": "Everything you need for a complete and spiritual Pooja ceremony, curated with care.",
  "General": "Explore our wide range of spiritual products designed to bring peace to your life."
};

const ProductCard = ({ product }) => {
    // Reusing a simple card layout for the list
    const image = (product.productPhotos && product.productPhotos.length > 0) 
        ? (product.productPhotos[0].photoName || product.productPhotos[0]) 
        : "/assets/images/Rectangle 129.png";
        
    return (
        <div className="col-md-4 mb-4">
             <Link to={`/product/${product.productId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="card h-100 border-0 shadow-sm p-3" style={{ borderRadius: '15px' }}>
                    <div style={{ background: '#f8f9fa', borderRadius: '15px', padding: '20px', textAlign: 'center' }}>
                         <img src={image} alt={product.productName} style={{ height: '150px', objectFit: 'contain' }} />
                    </div>
                    <div className="card-body text-center">
                        <h5 className="card-title fw-bold">{product.productName}</h5>
                        <p className="text-muted">₹{product.productPrice}</p>
                    </div>
                </div>
            </Link>
        </div>
    )
}

const CategoryDetails = () => {
  const { categoryName } = useParams(); // Get "Dhoop" from URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategoryProducts = async () => {
      try {
        // Fetch ALL products and filter (Temporary until backend has specific endpoint)
        const response = await api.get('/products/hiddenFalse');
        const allProducts = response.data;
        
        // Filter locally
        const filtered = allProducts.filter(p => 
            (p.category || "General").toLowerCase() === categoryName.toLowerCase()
        );
        
        setProducts(filtered);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching category products", error);
        setLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [categoryName]);

  const description = MOCK_DESCRIPTIONS[categoryName] || "Discover our exclusive collection.";

  return (
    <div className="container py-5" style={{ minHeight: '80vh' }}>
      
      {/* HEADER SECTION */}
      <div className="text-center mb-5">
         <h1 className="fw-bold display-4" style={{ color: '#333' }}>{categoryName}</h1>
         <div style={{ width: '60px', height: '4px', background: '#FFC35B', margin: '10px auto' }}></div>
         <p className="lead text-muted mt-3" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {description}
         </p>
      </div>

      {/* PRODUCTS GRID */}
      {loading ? (
          <div className="text-center"><h4>Loading...</h4></div>
      ) : (
          <div className="row">
             {products.length > 0 ? (
                 products.map(p => <ProductCard key={p.productId} product={p} />)
             ) : (
                 <div className="text-center col-12">
                     <h5>No products found in this category yet.</h5>
                 </div>
             )}
          </div>
      )}
    </div>
  );
};

export default CategoryDetails;